import { render } from "./AccountView.vue?vue&type=template&id=5aebe19e&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import "./AccountView.vue?vue&type=style&index=0&id=5aebe19e&scoped=true&lang=css"
import "./AccountView.vue?vue&type=style&index=1&id=5aebe19e&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aebe19e"]])

export default __exports__